import { Injectable } from '@angular/core';
import { PaginatorResponse, ResponseData } from '@klickdata/core/http';
import { ResourceStaffRoles } from '@klickdata/core/resource/src/types.enum';
import { TableHttpHelpers, TableHttpService, TableSource } from '@klickdata/core/table';
import { User, UserData, UserService } from '@klickdata/core/user';
import { Utils } from '@klickdata/core/util';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class UserListingService extends UserService implements TableHttpService<User> {
    private eager: string[] = ['tags,task,managers,activations'];

    public addEager(eager: string | string[]) {
        if (Utils.isEmpty(eager)) return;
        const items = typeof eager === 'string' ? eager.split(',') : eager;
        this.eager.push(...items);
    }

    public fetchData(source: TableSource<User>): Observable<ResponseData<User[]>> {
        const req = this.builder.get<UserData[]>(this.resourceUrl);
        TableHttpHelpers.managePagination(source.paginator, req);
        TableHttpHelpers.manageSort(source.sort, req);
        TableHttpHelpers.mapFilter(source.filter, req);
        req.param('customer', null);
        req.putEager(this.eager);

        return req.request().pipe(
            map((res: PaginatorResponse<UserData[]>) => {
                return {
                    data: res.data.map((user) => this.mapUser(user)),
                    notify: res.notify,
                    more: res.more,
                    paginator: res.paginator,
                };
            })
        );
    }
}
